import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IVersioningOptions } from "../../../core/models/common";

/**
 * This component provides a dropdown or selection interface for versioning options.
 * It allows users to select a versioning option and provides a configurable UI
 * with tooltips and a customizable button.
 */
@Component({
  selector: "app-versioning-select",
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: "./versioning-select.component.html",
  styleUrl: "./versioning-select.component.scss",
})
export class VersioningSelectComponent {
  /**
   * Input property to provide data for the versioning options.
   * Expected to contain relevant information for versioning selection.
   */
  @Input()
  data: any = {};

  /**
   * Input property to customize the options for the versioning component.
   * Allows overriding the default configuration, including labels, tooltips, and button text.
   */
  @Input()
  options: any = {};

  defaultOptions: IVersioningOptions = {
    label: "Select Versioning of Test Cases",
    tooltipText: "Generate test cases based on selected version",
    tooltipIcon: "info",
    button: {
      text: "Go",
    },
  };

  /**
   * Lifecycle hook that initializes the component.
   * Merges the provided options with the default configuration to finalize the settings.
   */
  ngOnInit() {
    this.defaultOptions = { ...this.defaultOptions, ...this.options };
  }
}
